import {
  NumberInput,
  coerceNumberProperty,
  coerceCssPixelValue,
} from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type Variant = 'rectangular' | 'rounded' | 'circular';

@Component({
    selector: 'lui-skeleton',
    templateUrl: './skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkeletonComponent {
  @HostBinding('class') className = {
    'lui-skeleton': true,
    'lui-skeleton-rectangular': false,
    'lui-skeleton-circular': false,
  };

  @Input() get height(): string | number {
    return this._height;
  }
  set height(value: NumberInput | string) {
    this._height = coerceNumberProperty(value);
    this.heightStyle = coerceCssPixelValue(value);
  }
  _height!: string | number;

  @Input() get width(): string | number {
    return this._width;
  }
  set width(value: NumberInput | string) {
    this._width = coerceNumberProperty(value);
    this.widthStyle = coerceCssPixelValue(value);
  }
  _width!: string | number;

  @HostBinding('style.--height') heightStyle!: string;

  @HostBinding('style.--width') widthStyle!: string;

  @Input() get variant(): Variant {
    return this._variant;
  }
  set variant(value: Variant) {
    this.className = {
      'lui-skeleton': true,
      'lui-skeleton-rectangular': value === 'rectangular',
      'lui-skeleton-circular': value === 'circular',
    };

    this._variant = value;
  }
  private _variant: Variant = 'rounded';
}
